
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/guides/responsive-ui",
      function () {
        return require("private-next-pages/material-ui/guides/responsive-ui.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/guides/responsive-ui"])
      });
    }
  